import { Link, useStaticQuery, graphql } from "gatsby";
import * as React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../components/layout";
import { StaticImage } from "gatsby-plugin-image";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import LocalBusinessSchema from "../components/schema/localBusinessSchema";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import HorizontalTestimonial from "../components/horizontal-testimonial";
import BackgroundImage from "gatsby-background-image";
import CtaBanner from "../components/cta-banner";
import { BiCog } from "react-icons/bi";
import { GiSpade } from "react-icons/gi";
import { BiTime } from "react-icons/bi";
import ReactPlayer from "react-player";
// import {IoAnalytics} from "react-icons/io"
// import {IoMdRocket} from "react-icons/io"
// import {FaBinoculars} from "react-icons/fa"

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      seoImg: file(relativePath: { eq: "1.jpg" }) {
        publicURL
        childImageSharp {
          fluid(quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      heroImg: file(relativePath: { eq: "jason-client-meeting-5.jpg" }) {
        publicURL
        childImageSharp {
          fluid(quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      executive: file(relativePath: { eq: "4.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mark: file(relativePath: { eq: "testimonials/mark-wiffen.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      fran: file(relativePath: { eq: "testimonials/lou.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      tania: file(relativePath: { eq: "testimonials/Claire freemen New.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      billy: file(relativePath: { eq: "testimonials/Billy-Cook.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      heba: file(relativePath: { eq: "testimonials/Heba-Ghazi.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      nick: file(relativePath: { eq: "testimonials/nick-bryant.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      aliceS: file(relativePath: { eq: "testimonials/Dr-Alice-Scott.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      beng: file(relativePath: { eq: "testimonials/beng.jpeg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      mattG: file(relativePath: { eq: "testimonials/MatthewGiles.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, width: 400)
        }
      }
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const siteUrl = data.site.siteMetadata.siteUrl;
  const schemaImage = data.seoImg.publicURL;
  const executive = data.executive.childImageSharp.fluid;
  const mark = data.mark.childImageSharp.gatsbyImageData;
  const fran = data.fran.childImageSharp.gatsbyImageData;
  const tania = data.tania.childImageSharp.gatsbyImageData;
  const nick = data.nick.childImageSharp.gatsbyImageData;
  const ogImg = `${siteUrl}${schemaImage}`;
  const billy = data.billy.childImageSharp.gatsbyImageData;
  const heba = data.heba.childImageSharp.gatsbyImageData;
  const aliceS = data.aliceS.childImageSharp.gatsbyImageData;
  const beng = data.beng.childImageSharp.gatsbyImageData;
  const mattG = data.mattG.childImageSharp.gatsbyImageData;

  const breadcrumb = {
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: {
          url: `${siteUrl}`,
          id: `${siteUrl}`,
        },
      },
    ],
  };

  return (
    <Layout>
      <Helmet>
        {" "}
        <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      </Helmet>
      <LocalBusinessSchema />
      <GatsbySeo
        title="Business Coach London UK | Grow the business you truly want"
        description="Grow the business you truly want with a proven Business Coach London. Create a vision and make it happen. No excuses just results."
        language="en"
        openGraph={{
          type: "website",
          url: `${siteUrl}`,
          title: "Business Coach London | Jason Cornes",
          description: "Business Coaching London for the self-employed",
          images: [
            {
              url: `${ogImg}`,
              width: 1920,
              height: 1080,
              alt: "Jason Cornes Business Coach London",
            },
          ],
        }}
      />
      <section id="hero-homepage">
        <Container fluid>
          <Row className="align-items-lg-center justify-content-between ">
            <Col
              xs={{ span: 12, order: "first" }}
              lg={{ span: 6, order: "first" }}
              xl={{ span: 5, order: "first" }}
              className="px-0 pl-lg-0  mb-4 pe-xl-5 mt-lg-0 order-lg-0"
            >
              <div className="d-none d-lg-block">
                <ReactPlayer
                  title="Jason Cornes"
                  controls
                  className="w-100 h-auto"
                  url="https://jason-cornes.rjmdigital.net/wp-content/uploads/2025/11/2026-Jason-Cornes-Square.mp4"
                />
              </div>

              <div className="d-lg-none">
                <ReactPlayer
                  title="Jason Cornes"
                  controls
                  className="w-100 h-auto"
                  url="https://jason-cornes.rjmdigital.net/wp-content/uploads/2025/12/2026-Jason-Cornes-Landscape.mp4"
                />
              </div>

              {/* <div className="iframe-container-hero mb-4">
								<iframe
									loading="eager"
									className="responsive-iframe-hero"
									src="https://www.youtube.com/embed/mT2OT55F-gk?autoplay=1&mute=1"
									title="Jason Cornes"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen
								></iframe>
							</div> */}
              {/* <div className=" iframe-container-hero ">
								<ReactPlayer
									className="responsive-iframe-hero w-100 h-100"
									playing
									muted
									controls
									url="https://jason-cornes.rjmdigital.net/wp-content/uploads/2023/06/Jason-Website-Intro-Video.mp4"
								/>
							</div> */}
            </Col>
            <Col
              xs={12}
              lg={6}
              xl={7}
              className="text-left pl-lg-5 pl-xl-5  order-md-0 order-lg-1"
              id="hero-text"
            >
              <p className="text-secondary hind-bold pt-3" id="jc">
  Jason Cornes
</p>

<h1 style={{ fontSize: "3rem" }} className="text-primary">
  Business Coach London
</h1>

<p className="text-primary benefits">
  Trusted Thinking Partner for Ambitious Business Owners
</p>

<ul className="py-3">
  <li className="text-primary benefits">
    Gain clarity about the next chapter
  </li>
  <li className="text-primary benefits">
    Create a plan and make it happen
  </li>
  <li className="text-primary benefits">
    Make important decisions with confidence
  </li>
</ul>

<p className="text-primary benefits">
  With Jason Cornes as your Hidden Business Partner
</p>

<p className="text-primary benefits">
  40 Years in Business | MBA Qualified | 120+ Client Testimonials
</p>
              <Button
                className="cta-btn mt-3 cta-btn-gtm"
                variant="secondary"
                size="lg"
                as={Link}
                to="/contact-us"
              >
                Book a discovery meeting<span>{` `}</span> &#8594;
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="introduction" className="pt-5">
        <Container>
          <Row className="text-left text-md-center">
            <Col>
              <h3 id="years-in-business">
                With nearly 40 years’ experience in business with clients across
                the UK, USA and worldwide, Jason works with ambitious business
                and practice owners like you, the single decision-maker who’s
                ready for change but often feels alone in business.
              </h3>
            </Col>
          </Row>
          <Row className="text-left text-md-center">
            <Col>
              <h4 className="mt-4">
                You may recognise yourself in one or more of these:
              </h4>
            </Col>
          </Row>
          <Row className="text-center py-5">
            <Col xs={12} md={4} className="pt-4 px-5">
              <BiCog className="text-primary icon" />
              <h3 className="text-tertiary">Frustrated</h3>
              <p>
                You’ve achieved some success, but it feels like you’ve hit a
                ceiling. You know there’s more potential, yet you can’t quite
                see how to unlock it.
              </p>
            </Col>
            <Col xs={12} md={4} className="pt-4 px-5">
              <GiSpade className="text-primary icon" />
              <h3 className="text-tertiary">Determined</h3>
              <p>
                You’re ready to take control - enough is enough. It’s time to
                stop reacting to whatever comes your way and start shaping the
                business you really want.
              </p>
            </Col>
            <Col xs={12} md={4} className="pt-4 px-5">
              <BiTime className="text-primary icon" />
              <h3 className="text-tertiary">Overwhelmed</h3>
              <p>
                You’re juggling too many plates, busy every day with a seemingly
                endless to-do list, but unsure which activities truly move the
                business forward.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <Col>
              <StaticImage
                className="float-right mb-4 my-xl-1 ml-xl-3 service-page-body-image"
                src="../images/11.jpg"
                quality={100}
                alt="Jason Cornes Business Coach London"
              />
              <p>
                Regardless of where you are right now, one thing is likely true:
                you want to spend more time working on your business rather than
                in it. Have more money and time to enjoy life with the people
                who matter most.
              </p>
              <p>
                If you woke up tomorrow able to tap into your full potential and
                make things happen, what changes would you make instantly to
                your business and your life?
              </p>
              <p>
                Whether you want to scale, simplify or create more freedom to do
                what you love with those you love, Jason will help you overcome
                the obstacles holding you back and build a business and a life
                you’re truly proud of.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="bg-white py-5">
        <Container>
          <Row className="g-5">
            <Col lg={4}>
              <div className="iframe-container-new mb-4">
                <ReactPlayer
                  title="Jason Cornes"
                  controls
                  className="responsive-iframe w-100 h-100"
                  url="https://jason-cornes.rjmdigital.net/wp-content/uploads/2025/12/Jason-Cornes-Testimonial-Mash-Up.mp4"
                />
              </div>
            </Col>
            <Col lg={4}>
              {" "}
              <div className="iframe-container-new mb-4">
                <iframe
                  loading="lazy"
                  className="responsive-iframe"
                  src="https://www.youtube.com/embed/WAwwhJQUr-U"
                  title="Testimonial | Jason Cornes"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
              </div>
            </Col>
            <Col lg={4}>
              {" "}
              <div className="iframe-container-new mb-4">
                <iframe
                  loading="lazy"
                  className="responsive-iframe"
                  src="https://www.youtube.com/embed/3YNLOv1N2BE?si=S9yjmywc36Bpyhw7"
                  title="Testimonial Two | Jason Cornes"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="bg-primary text-white py-5">
        <Container>
          <Row>
            <Col>
              <h2 className="pb-3">So, what’s holding you back right now?</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <ul className="pl-4">
                <li>
                  Do you feel stuck - unsure what your next step should be or
                  how to create a clear new vision for your business?
                </li>
                <li>
                  Have you achieved some success but know, deep down, there’s
                  much more potential waiting to be unlocked?
                </li>
                <li>
                  Would you value an experienced, independent non-judgemental
                  sounding board to challenge your thinking and offer a fresh
                  perspective?
                </li>
                <li>
                  Are you struggling to focus - spread too thin, second-guessing
                  decisions, or battling limiting beliefs or assumptions that
                  hold you back?
                </li>
                <li>
                  Are you constantly busy, yet feel you’re not moving forward in
                  the direction you truly want to go?
                </li>
                <li>
                  Or perhaps the pressures of work, family and everyday life are
                  leaving you feeling drained - ready to create some boundaries
                  and start saying “no” to what doesn’t serve you anymore.
                </li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                If this sounds familiar, business coaching with Jason will be
                the turning point you’ve been looking for. A firm but
                empathetic, structured, supportive partnership to help you
                regain clarity, confidence, and control.
              </p>
              <p>
                Keep reading to see how Jason’s coaching approach will help you
                think bigger, act with purpose and achieve the results you
                deserve.
              </p>
              <p>
                Or if you’re ready to explore how this could look for you, book
                a complimentary discovery Zoom meeting today and start the
                conversation.
              </p>
            </Col>
          </Row>
          <Row className="text-center pt-4">
            <Col className="d-flex align-items-center flex-column flex-md-row">
              <Button
                variant="outline-light"
                className="cta-btn cta-btn-gtm mr-md-4"
                size="lg"
                as={Link}
                to="/contact-us"
              >
                Book a discovery meeting
              </Button>
              <Button
                as={Link}
                variant="outline-light"
                className="float-md-right w-fit cta-btn-gtm px-4 mt-4 mt-md-0"
                href={"https://quiz.jasoncornes.co.uk"}
                size="lg"
              >
                Quiz: Discover your business personality
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5">
        <Container>
          <Row className="pb-5">
            <Col>
              <h2 className="text-primary">
                How will Jason Cornes, Business Coach in London, help you?
              </h2>
            </Col>
          </Row>
          <HorizontalTestimonial
            name="Dr Alice Scott. General Practitioner and Menopause Specialist. Essex Private Doctors."
            review="Starting coaching with Jason is the best business decision I’ve made. His calm, encouraging approach has been invaluable, helping me step back and make better decisions as I continue to grow."
            linkedIn="https://www.linkedin.com/in/dr-alice-scott-45b268118/"
            profilePic={aliceS}
          />

          <HorizontalTestimonial
            name="Heba Ghazi. Heba Ghazi Designs Ltd"
            review="Jason helped me go far beyond surface-level fixes. He helped me understand who I am, recognise my strengths in a new way and gain real clarity and confidence in my business."
            profilePic={heba}
            linkedIn="https://www.linkedin.com/company/heba-ghazi-designs/"
          />

          <HorizontalTestimonial
            name="Ben Gottlieb. Gottlieb Law PLC"
            review="Jason is an outstanding business coach. He provides clear-headed advice and brings business psychology into his coaching. Highly recommended."
            profilePic={beng}
            linkedIn="https://www.linkedin.com/in/ben-gottlieb-038a8550"
          />

          <HorizontalTestimonial
            name="Matt Giles. Matthew Giles Architects."
            review="Jason may take you out of your comfort zone. I say let him. He strips things back, challenges what you think you know and that’s how real progress happens."
            profilePic={mattG}
            linkedIn="https://www.linkedin.com/company/matthew-giles-architects/"
          />

          {/* <HorizontalTestimonial
            name="Louise McIntyre. Printingprogress Ltd"
            review="Jason is a breath of fresh air and an incredibly talented business coach. If you are looking for someone to inspire you and help you to see how you can grow both your self-confidence and business then look no further. I have had many business coaches that work to a model that has never quite suited me or my business, but Jason is different he adapts his expertise and meets you exactly where he makes the most impact. Highly Recommended."
            linkedIn="https://www.linkedin.com/in/lou-mcintosh-712ab920"
            profilePic={fran}
          /> */}

          {/* <HorizontalTestimonial
            name="Mark Wiffen. Marlin Architectural Design Ltd"
            review="I have been working with Jason since the beginning of 2021 and in that time have started outsourcing certain areas of my work as a direct result of Jason's encouragement and guidance. This is now enabling me to bring forward my life-long plan of reducing my working week to 4 days to the beginning of 2022, whereas previously it would have been April 2023. Jason has a knack of subtly pushing you further than you feel you want to go. This is enabling me to drive the business forward taking on more work to improve profits at the same time as reducing my hours. Anyone needing business advice would benefit to the better for their sessions with Jason."
            linkedIn="https://www.linkedin.com/in/mark-wiffen-3244a427/"
            profilePic={mark}
          /> */}

          <HorizontalTestimonial
            name="Claire Freeman. Consultant Podiatric Surgeon FRCPodS"
            review="When I spoke to Jason, I immediately recognised his skill and professionalism. Would I choose him again? Absolutely. Is my business better off? Absolutely."
            profilePic={tania}
            linkedIn="https://www.linkedin.com/in/claire-freeman-frcpods-consultant/"
          />
          {/* <HorizontalTestimonial
            name="Billy Cook. Scriptmaster International"
            review="Jason is wonderful blend of both an immensely calming presence and pragmatic no-nonsense business sense. If you’re like me and your mind is a maelstrom of ideas and wrestling questions, having Jason in your corner will be invaluable for making simpler music from that noise. His guidance quickly oriented me and helped me identify routes to a better financial situation along paths with the lowest hanging fruit – aligned with what I want to do with my life. I had met other coaches before and what has set Jason apart for me is that he is able to mentor as much as a coach. What I mean by this is that “coaching” is fine, but sometimes (often) I don’t want to spend an hour mulling introspective personal explorations and I found that having someone who has been there and done it meant I got to practical, actionable answers, plans and insights far faster than coaching has got for me before. This will be a personality and taste thing - but the good news for you is Jason does both!"
            profilePic={billy}
            linkedIn="https://www.linkedin.com/in/billymcook/"
          /> */}

          <Row className="text-center pt-4 pb-6">
            <Col>
              <Button
                variant="outline-secondary"
                className="cta-btn cta-btn-gtm"
                size="lg"
                as={Link}
                to="/written-testimonials"
              >
                View 100+ client testimonials in full
              </Button>
            </Col>
          </Row>
          <Row className="g-5">
            <Col lg={6}>
              {" "}
              <div className="iframe-container-new mb-4">
                <iframe
                  loading="lazy"
                  className="responsive-iframe"
                  src="https://www.youtube.com/embed/sp2-RfrN7jU"
                  title="Testimonial Two | Jason Cornes"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
              </div>
            </Col>

            <Col lg={6}>
              {" "}
              <div className="iframe-container-new mb-4">
                <iframe
                  loading="lazy"
                  className="responsive-iframe"
                  src="https://www.youtube.com/embed/r4bKsNpKzqE"
                  title="Testimonial Three | Jason Cornes"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
              </div>
            </Col>
          </Row>
          <Row className="text-center pt-4">
            <Col>
              <Button
                variant="outline-secondary"
                className="cta-btn cta-btn-gtm"
                size="lg"
                as={Link}
                to="/written-testimonials"
              >
                Read more testimonials
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5">
        <Container>
          <Row>
            <Col>
              <p>
                "The best investment you can make is in yourself, the more you
                learn, the more you earn.” — Warren Buffett
              </p>
              <p>
                When you invest in your personal growth as a business leader, it
                will impact your bottom line.
              </p>
              <p>
                Business and executive coaching with Jason will give you a whole
                new set of ideas, action points and goals. But above all, it
                helps you to:
              </p>

              <ul>
                <li>
                  Improve your business mindset and increase profitability.
                </li>
                <li>
                  Explore opportunities and challenges with a neutral,
                  non-judgmental sounding board.
                </li>
                <li>
                  Reveal the things you miss, those blind spots that are holding
                  you back.
                </li>
                <li>Overcome assumptions and self-limiting beliefs.</li>
                <li>
                  Get unstuck by developing an action plan to propel you
                  forward.
                </li>
                <li>
                  Become a more effective, decisive leader and a shining example
                  to others.
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <section className="pb-5">
				<Container>
					<Row>
						<Col>
							<iframe
								loading="lazy"
								width="100%"
								height="500"
								src="https://www.youtube.com/embed/10-i8h0ZnYE"
								title="Business Coach London | Jason Cornes"
								frameborder="0"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowfullscreen
							></iframe>
						</Col>
					</Row>
				</Container>
			</section> */}
      <BackgroundImage
        style={{ backgroundPosition: "center" }}
        className="position-relative"
        tag="section"
        fluid={executive}
        alt="Jason Cornes delivering a Business Coaching session in London"
      >
        <div
          style={{ background: "black", opacity: 0.3, zIndex: 1 }}
          className="position-absolute w-100 h-100 start-0"
        ></div>
        <Container
          style={{ zIndex: 2 }}
          className="py-5 py-lg-8 position-relative"
        >
          <Row className="text-center">
            <Col>
              <h3 className="text-white pb-3">
                Looking for Self-Employed Business Mentoring?
              </h3>
              <Button
                variant="secondary"
                className="cta-btn cta-btn-gtm"
                as={Link}
                size="lg"
                to="/business-mentoring"
              >
                Find out More
              </Button>
            </Col>
          </Row>
        </Container>
      </BackgroundImage>

      <section className="py-5">
        <Container>
          <Row>
            <Col>
              <h2 className="pb-3">What it’s like working with Jason?</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                Clients describe sessions with Jason as practical, focused and
                deeply supportive. He listens carefully, asks the right
                questions and helps you see new angles and possibilities you
                might have missed. Each meeting ends with clear actions and
                renewed motivation. No jargon, no fluff, just honest progress.
              </p>
              <p>
                You’ll find him down-to-earth, encouraging, enthusiastic and
                completely confidential. A non-judgemental sounding board who
                understands both the strategic and emotional sides of running a
                business.
              </p>
              <p>
                Jason works primarily with self-employed professionals and
                single-director business owners in any sector. From lawyers,
                accountants and medical specialists, to coaches, consultants,
                designers and other creative entrepreneurs.
              </p>
              <p>
                If you’re ready for clarity, structure and accountability, Jason
                will be your ‘Hidden Business Partner’ walking beside you as you
                and your business grow.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="">
        <Container>
          <Row>
            <Col>
              <h2 className="pb-3">What coaching isn’t about</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                Coaching isn’t a one-size-fits-all process. You’re unique and
                your goals, challenges and circumstances are your own, so your
                coaching with Jason will always be{" "}
                <strong>tailor-made for you</strong>.
              </p>
              <p>
                He is not a consultant won’t tell you what to do. Instead,
                you’ll build a working partnership where you make the decisions,
                supported by his experience and suggestions, structure, and
                perspective. He’ll challenge your thinking, offer practical
                suggestions and help you see the options you might not have
                considered.
              </p>

              <p>
                At the same time, Jason will hold you accountable. At the end of
                each session, you’ll leave with clear actions designed to move
                you forward. His role isn’t to run your business, it’s to help
                you set meaningful goals, take consistent action and achieve the
                progress you’ve been looking for.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5">
        <Container>
          <Row>
            <Col>
              <h2 className="pb-3">Confidential coaching</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                Jason has experienced the highs and lows of business life
                first-hand and understands how tough and lonely it can feel at
                the top. All of his coaching is delivered one-to-one, 100%
                confidential and completely non-judgemental. Clients value the
                safe, open environment Jason creates where they can talk
                honestly about both business and personal challenges without
                fear of criticism or bias.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 bg-tertiary text-white">
        <Container>
          <Row>
            <Col>
              <h2>Learn more about coaching</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <p>
                Jason meets clients regularly via Zoom, helping them grow in
                confidence with the leadership and business skills needed to
                strengthen and expand their small businesses.
              </p>

              <p>
                To discover how business and executive coaching can help you
                transform your business or career over the next year, click
                below to book a complimentary, no-obligation discovery call with
                Jason.
              </p>
              <p>
                Explore his written and video testimonials to hear what clients
                say about their experience of working with him.
              </p>
            </Col>
          </Row>
          <Row className="text-center">
            <Col>
              <Button
                variant="outline-light"
                className="cta-btn cta-btn-gtm"
                as={Link}
                size="lg"
                to="/written-testimonials"
              >
                Read more testimonials
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      <CtaBanner
        headline="Ready to Book a discovery meeting?"
        btnTxt="Get in Touch"
        btnLink="/contact-us"
        bgColor="light"
      />
      <section className="py-5">
        <Container>
          {/* <Row>
            <Col>
              <h2>My Coaching and Mentoring Services</h2>
                          </Col>
          </Row> */}
          <Row>
            {/* <Col className="text-center mb-4" xs={12} md={4}>
              <StaticImage
                src="../images/jason-client-meeting-3.jpg"
                style={serviceimg}
                quality={100}
              />
              <h3 className="py-3 cta-btn-gtm">Business Coaching</h3>
              <Button variant="outline-secondary" as={Link} to="/">
                Find Out More
              </Button>
            </Col> */}

            <Col className="text-center mb-4" xs={12} md={6} lg={4}>
              <StaticImage
                src="../images/1.jpg"
                style={serviceimg}
                quality={100}
                alt="Jason Cornes in a client meeting delivering a Business Coach London session"
              />
              <h3 className="py-3">Packages and Pricing</h3>
              <Button
                className="cta-btn-gtm"
                variant="outline-secondary"
                as={Link}
                to="/packages"
              >
                Find Out More
              </Button>
            </Col>
            <Col className="text-center mb-4" xs={12} md={6} lg={4}>
              <StaticImage
                src="../images/14.jpg"
                style={serviceimg}
                quality={100}
              />
              <h3 className="py-3">About Jason</h3>
              <Button
                className="cta-btn-gtm"
                variant="outline-secondary"
                as={Link}
                to="/about"
              >
                Find Out More
              </Button>
            </Col>
            <Col
              className="text-center mb-4 mt-md-4 mt-lg-0"
              xs={12}
              md={{ span: 6, offset: 3 }}
              lg={{ span: 4, offset: 0 }}
            >
              <StaticImage
                src="../images/2.jpg"
                style={serviceimg}
                quality={100}
                alt="Business Coach London session with Jason Cornes"
              />
              <h3 className="py-3 px-md-4 px-lg-0">
                Frequently Asked Questions
              </h3>
              <Button
                className="cta-btn-gtm"
                variant="outline-secondary"
                as={Link}
                to="/frequently-asked-questions"
              >
                Find Out More
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
};

const serviceimg = {
  minHeight: "290px",
};

export default IndexPage;
